import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAdjust, faTextHeight } from '@fortawesome/free-solid-svg-icons'
import './accessibility-toggles.css'
import { AccessibilityToggle } from './accessibility-toggle'

export const TOGGLE_KEY_HIGH_CONTRAST = 'highContrast'
export const TOGGLE_KEY_LARGE_TEXT = 'largeText'

export function AccessibilityToggles({
  onToggleHighContrast,
  onToggleLargeText,
}: {
  onToggleHighContrast: Function
  onToggleLargeText: Function
}) {
  return (
    <div className="accessibility-toggles">
      <AccessibilityToggle
        toggleKey={TOGGLE_KEY_HIGH_CONTRAST}
        tooltip="Toggle high contrast mode"
        onToggle={(newValue: string) => {
          onToggleHighContrast(newValue)
        }}
      >
        <FontAwesomeIcon icon={faAdjust} />
      </AccessibilityToggle>
      <AccessibilityToggle
        toggleKey={TOGGLE_KEY_LARGE_TEXT}
        tooltip="Toggle large text mode"
        onToggle={(newValue: string) => {
          onToggleLargeText(newValue)
        }}
      >
        <FontAwesomeIcon icon={faTextHeight} />
      </AccessibilityToggle>
    </div>
  )
}
